import { useEffect, useState } from 'react';
import { base64ToBlob, base64urlToBase64 } from '../../../../../utils/Base64ToBlob';
import { FingerprintStatus } from '../Model/Models';
import { toast } from 'react-toastify';
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */
const FingerprintStepApp = ({
    setCapturedFingerprint,
    setFingerprintSrc,
    setCapturing,
    capturedFingerprint,
    updatedFinger,
    setFingerprintName,
    setSelectedReader,
    fingerprintsList,
    setUpdated,
    setModified,
    userData,
    fingerprintsTemp,
    setFingerprintsTemp,
    mergedFingerprints,
}) => {


    const [fingerprintStatus, setFingerprintStatus] = useState(FingerprintStatus.INITIAL);
    const [selectFingerprintsForDelete, setSelectFingerprintsForDelete] = useState([]);
    const [isAllCheckedFingerprints, setIsAllCheckedFingerprints] = useState(false);
    const [deleteFingerprintsShow, setDeleteFingerprintsShow] = useState(false);
    const [start, setStart] = useState(false);
    const [sdk, setSdk] = useState(null);

   const validateFingerprintService = async () => {
    const sdk = new window.Fingerprint.WebApi();
    await sdk.enumerateDevices();
    return true;
};

    /**
     * Initializes fingerprint SDK and starts acquisition process.
     */
    useEffect(() => {
        if (!start) return;

        if (!window.Fingerprint?.WebApi) {
            setFingerprintStatus(FingerprintStatus.NO_DEVICE);
            return;
        }

        let instance = null;

        try {
            const FingerprintSdk = function () {
                this.sdk = null;
            };

            FingerprintSdk.prototype.start = function () {
                this.sdk = new window.Fingerprint.WebApi();

                this.sdk.on('SamplesAcquired', (event) => {
                    try {
                        if (!event?.samples) return;

                        setFingerprintStatus(FingerprintStatus.CAPTURING);

                        setTimeout(() => {
                            try {
                                const resp = JSON.parse(event.samples);
                                if (!resp?.length) return;
                                const parsedData = JSON.parse(atob(resp[0].Data));
                                const wsqBase64 = base64urlToBase64(parsedData.Data);
                                const wsqBlob = base64ToBlob(wsqBase64, 'application/octet-stream');
                                setCapturedFingerprint(wsqBlob);
                                setFingerprintSrc(wsqBase64);
                            } catch (e) {
                                console.error('[FP] parse error:', e);
                            }
                        }, 300);
                    } catch (e) {
                        console.error(e);
                    }
                });
            };

            FingerprintSdk.prototype.startCapture = function (id) {
                const format = window.Fingerprint?.SampleFormat?.Compressed;

                this.sdk.startAcquisition(format, id).then(() => {
                    setCapturing(true);
                    setFingerprintStatus(FingerprintStatus.PUT_FINGER);
                });
            };

            FingerprintSdk.prototype.stopCapture = function () {
                this.sdk.stopAcquisition().then(() => setCapturing(false));
            };

            FingerprintSdk.prototype.getDeviceList = function () {
                return this.sdk.enumerateDevices();
            };

            instance = new FingerprintSdk();
            instance.start();

            instance.getDeviceList().then((devices) => {
                if (!devices?.length) {
                    setFingerprintStatus(FingerprintStatus.NO_DEVICE);
                    setStart(false);
                    setCapturing(false);
                    return;
                }

                setFingerprintStatus(FingerprintStatus.CONNECTED);

                setSelectedReader(devices[0]);
                instance.startCapture(devices[0]);
                setSdk(instance);
            });
        } catch (e) {
            console.error('[FP] error:', e);
            setFingerprintStatus(FingerprintStatus.NO_DEVICE);
        }

        return () => {
            if (instance) instance.stopCapture();
        };
    }, [start]);


    /**
     * Starts fingerprint capture process.
     */
  const handleCaptureFinger = async () => {
    try {
        const serviceAvailable = await validateFingerprintService();

        if (!serviceAvailable) {
            setFingerprintStatus(FingerprintStatus.NO_DRIVER);
            return;
        }

        setStart(true);
    } catch (error) {
        setFingerprintStatus(FingerprintStatus.NO_DRIVER);
    }
};

    /**
     * Cancels fingerprint capture flow.
     */
    const handleCancel = () => {
        setFingerprintStatus(FingerprintStatus.INITIAL);
        setStart(false);
        setFingerprintName('');
    };


    /**
     * Finalizes capture process after fingerprint is acquired.
     */
    useEffect(() => {
        if (capturedFingerprint && sdk) {
            setTimeout(() => {
                sdk.stopCapture();
                setCapturing(false);
                setFingerprintStatus(FingerprintStatus.CAPTURED);
                setStart(false);
            }, 700);
        }
    }, [capturedFingerprint]);


    /**
     * Resets fingerprint state after successful update.
     */
    useEffect(() => {
        if (updatedFinger) {
            setFingerprintName('');
            setSelectedReader('');
            setFingerprintSrc('');
            setFingerprintStatus(FingerprintStatus.INITIAL);
            setStart(false);
        }
    }, [updatedFinger]);

    /**
     * Clears current fingerprint data and resets state.
     */
    const handleClearFingerprint = () => {
        setFingerprintName('');
        setSelectedReader('');
        setFingerprintSrc('');
        setStart(false);
    };
    return {
        fingerprintStatus,
        isAllCheckedFingerprints,
        selectFingerprintsForDelete,
        deleteFingerprintsShow,
        setDeleteFingerprintsShow,
        setSelectFingerprintsForDelete,
        handleCaptureFinger,
        handleCancel,
        handleClearFingerprint,
        mergedFingerprints,
    };
};

export default FingerprintStepApp;
